import ServiceApi from '../services/service.api';
import { ResponseSchema } from '../schemas/getCases';
import { safeParse } from '../schemas/helpers/safeParse';

const baseServiceUrl = `/referrers`;

const ApiReferrers = {
  getPatientList: (params = {}) => {
    const url = `${baseServiceUrl}/patients/${ServiceApi.userGuid}`;
    return ServiceApi.get(url, { params });
  },
  getPatient: (patientGuid, params = { pat_guid: patientGuid }) => {
    const url = `${baseServiceUrl}/patients/${ServiceApi.userGuid}`;
    return ServiceApi.get(url, { params });
  },
  searchForCases: (params) => {
    const url = `/cases/${ServiceApi.userGuid}`;
    return ServiceApi.get(url, { params })
      .then((res) => ({ data: res?.data || { cases: [] }, status: res.status }))
      .then((res) => {
        return {
          data: safeParse(res.data, ResponseSchema),
          status: res.status
        };
      });
  },
  postEligibilityPolicy: (caseId, policyCode, applied, virtualOnlyReason) => {
    const body = {
      case_id: caseId,
      policy_code: policyCode,
      applied: applied,
      ...(virtualOnlyReason && { virtual_only_reason: virtualOnlyReason })
    };
    const url = `/admin/case/policy/${ServiceApi.userGuid}`;
    return ServiceApi.post(url, body);
  }
};

export default ApiReferrers;
